<template>
	<div class="loading">
		<img
			:src="HurtlePattern"
			alt="Loading Animation"
		/>
		<p>Loading Results</p>
	</div>
</template>

<script>
import HurtlePattern from '../../images/scroll_logo.png';

export default {
	data() {
		return {
			HurtlePattern: HurtlePattern,
		};
	},

	props: {},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.loading {
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	margin-top: $spacer * 4;
	margin-bottom: $spacer * 4;

	@media (max-width: $md) {
		margin-top: $spacer * 2;
		margin-bottom: $spacer * 2;
	}

	img {
		animation: rotate 3s linear infinite;
		width: 80px;
		height: 80px;
		z-index: 0;
		opacity: 0.75;
	}

	p {
		position: absolute;
		z-index: 10;
		font-size: 22px;
	}
}

@keyframes rotate {
	to {
		transform: rotate(360deg);
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/LoadingAnimation.vue